import { connect } from 'react-redux';

import {
  openBatchExecutionDetails,
  showStructurePopup,
} from '../../BreadcrumbsActions';
import StructureData from './StructureData';

const mapDispatchToProps = {
  openBatchExecutionDetails,
  showStructurePopup,
};

export default connect(null, mapDispatchToProps)(StructureData);
